module.exports = __webpack_public_path__ + "static/nav-background-sq-495103888773ef6a36b0cd19eee6a923.png";